/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Expense_Bulk_Category_SuccessInputs */

const vi_toast_expense_bulk_category_success = /** @type {(inputs: Toast_Expense_Bulk_Category_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đổi danh mục`)
};

/**

* @param {Toast_Expense_Bulk_Category_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_expense_bulk_category_success = /** @type {((inputs?: Toast_Expense_Bulk_Category_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Expense_Bulk_Category_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_expense_bulk_category_success(inputs)
});